module.exports = __webpack_public_path__ + "04_veryshort_grey.e1f7ca31.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_veryshort_grey.png
// module id = Jzy2
// module chunks = 0